const SectionTitle: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <div className="relative h-[35px] before:absolute before:bottom-0 before:left-0 before:w-[19px] before:h-[2px] before:bg-primary-400 before:rounded-md after:absolute  after:bottom-0 after:left-[20px] after:w-[9px] after:h-[2px] after:bg-primary-400 after:rounded-md">
      {children}
    </div>
  );
};

export default SectionTitle;
